import React from 'react';
import { Box, Card, CardContent, Skeleton, Stack } from '@mui/material';

export const OddsListSkeleton = ({ count = 3 }) => {
  return (
    <Stack spacing={2}>
      {Array.from({ length: count }).map((_, index) => (
        <Card key={index} elevation={1}>
          <CardContent sx={{ p: 2 }}>
            {/* Game header */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
              <Box sx={{ flex: 1 }}>
                <Skeleton variant="text" width="70%" height={24} />
                <Skeleton variant="text" width="40%" height={20} />
              </Box>
              <Skeleton variant="rectangular" width={60} height={24} sx={{ borderRadius: 1 }} />
            </Box>
            
            {/* Teams */}
            <Stack spacing={1} sx={{ mb: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Skeleton variant="text" width="40%" height={20} />
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Skeleton variant="rectangular" width={60} height={32} sx={{ borderRadius: 1 }} />
                  <Skeleton variant="rectangular" width={60} height={32} sx={{ borderRadius: 1 }} />
                  <Skeleton variant="rectangular" width={60} height={32} sx={{ borderRadius: 1 }} />
                </Box>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Skeleton variant="text" width="40%" height={20} />
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Skeleton variant="rectangular" width={60} height={32} sx={{ borderRadius: 1 }} />
                  <Skeleton variant="rectangular" width={60} height={32} sx={{ borderRadius: 1 }} />
                  <Skeleton variant="rectangular" width={60} height={32} sx={{ borderRadius: 1 }} />
                </Box>
              </Box>
            </Stack>

            {/* Sportsbooks */}
            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
              {Array.from({ length: 4 }).map((_, i) => (
                <Skeleton key={i} variant="rectangular" width={80} height={28} sx={{ borderRadius: 1 }} />
              ))}
            </Box>
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
};

export const SportsFilterSkeleton = () => {
  return (
    <Stack direction="row" spacing={1.5} sx={{ px: 0.5, pb: 2 }}>
      {Array.from({ length: 6 }).map((_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          width={index === 0 ? 90 : Math.floor(Math.random() * 40) + 60}
          height={40}
          sx={{ 
            borderRadius: 3,
            flexShrink: 0,
          }}
        />
      ))}
    </Stack>
  );
};

export const GameCardSkeleton = () => {
  return (
    <Card elevation={1}>
      <CardContent>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <Box>
            <Skeleton variant="text" width={180} height={24} />
            <Skeleton variant="text" width={120} height={20} />
          </Box>
          <Skeleton variant="circular" width={32} height={32} />
        </Box>
        
        <Skeleton variant="text" width="100%" height={20} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="80%" height={20} />
      </CardContent>
    </Card>
  );
};

export const NavigationSkeleton = () => {
  return (
    <Box sx={{ display: 'flex', gap: 1 }}>
      {Array.from({ length: 5 }).map((_, index) => (
        <Skeleton
          key={index}
          variant="rectangular"
          width={60}
          height={32}
          sx={{ borderRadius: 1 }}
        />
      ))}
    </Box>
  );
};

export const ProfileSkeleton = () => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2 }}>
      <Skeleton variant="circular" width={48} height={48} />
      <Box sx={{ flex: 1 }}>
        <Skeleton variant="text" width="60%" height={24} />
        <Skeleton variant="text" width="40%" height={20} />
      </Box>
    </Box>
  );
};